export const environment = {
    PRODUCTION: false,
    ENV: process.env['DEPLOY_ENV'] || '',
    IDENTITY_POOL_ID: process.env['IDENTITY_POOL_ID'] || '',
    USER_POOL_ID: process.env['USER_POOL_ID'] || '',
    USER_POOL_CLIENT_ID: process.env['USER_POOL_CLIENT_ID'] || '',
    AUTHORIZATION: 'Authorization',
    BEARER: 'Bearer',
    JWT_SECRET: process.env['JWT_SECRET'] || '',
    HUB_URL: process.env['HUB_URL'] || '',
};
